import {
  Heading,
  Icon,
  Box,
  SimpleGrid,
  HStack,
  Link as ChakraLink,
  Text,
  Checkbox,
  VStack,
  StackProps,
} from '@chakra-ui/react';
import { RiEyeLine } from 'react-icons/ri';
import { Link } from 'react-router-dom';
import { IUserBase } from '../../models/users';

interface IFiscalRecipientInfo extends StackProps {
  fiscalRecipient: IUserBase;
  onToggleFiscalRecipient?: () => void;
  userFiscalRecipient?: boolean;
  enableFiscalRecipientChange: boolean;
  hideFiscalRecipientCheckbox?: boolean;
}

const FiscalRecipientInfo = ({
  fiscalRecipient,
  onToggleFiscalRecipient,
  userFiscalRecipient = false,
  enableFiscalRecipientChange,
  hideFiscalRecipientCheckbox = false,
  ...rest
}: IFiscalRecipientInfo): JSX.Element => (
  <VStack spacing="4" align="left" {...rest}>
    <Heading size="md" fontWeight="normal">
      Destinatário da nota fiscal
    </Heading>

    {!hideFiscalRecipientCheckbox && !!onToggleFiscalRecipient && (
      <HStack>
        <Checkbox
          colorScheme="blue"
          borderColor="gray.300"
          isDisabled={!enableFiscalRecipientChange}
          isChecked={!userFiscalRecipient}
          onChange={() => onToggleFiscalRecipient()}
        />

        <Text>Usar dados do titular</Text>
      </HStack>
    )}

    <Box px="4">
      <SimpleGrid columns={[1, 1, 1, 1, 4]} spacing="4" w="100%">
        <Text fontSize="lg" fontWeight="bold">
          {fiscalRecipient.name}
        </Text>

        <HStack>
          <Text fontSize="sm">Telefone:</Text>
          <Text color="gray.500" fontSize="sm">
            {fiscalRecipient.phone}
          </Text>
        </HStack>

        <HStack>
          <Text fontSize="sm">E-mail:</Text>
          <Text color="gray.500" fontSize="sm">
            {fiscalRecipient.email}
          </Text>
        </HStack>

        <ChakraLink
          ml="auto"
          as={Link}
          to={{
            pathname: '/members/details',
            state: { memberId: fiscalRecipient.id },
          }}
        >
          <HStack>
            <Icon color="blue.300" as={RiEyeLine} fontSize="20" />
            <Text color="blue.300">Detalhes</Text>
          </HStack>
        </ChakraLink>
      </SimpleGrid>
    </Box>
  </VStack>
);

export default FiscalRecipientInfo;
